import React from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const HAS_COUNTERPARTY = "has_counterparty";
const NO_COUNTERPARTY = "no_counterparty";

const options: FilterMultiselectOption[] = [
    {
        value: HAS_COUNTERPARTY,
        label: "Has counterparty",
        searchableLabel: "has counterparty",
    },
    {
        value: NO_COUNTERPARTY,
        label: "Does not have counterparty",
        searchableLabel: "does not have counterparty",
    },
];

function counterpartyPresenceFromSelection(
    selected: FilterMultiselectValue[],
): {
    hasCounterparty: true | undefined;
    withEmptyOrUnverifiedCounterparty: true | undefined;
} {
    const isHasCounterpartySelected = selected.includes(HAS_COUNTERPARTY);
    const isNoCounterpartySelected = selected.includes(NO_COUNTERPARTY);
    if (isHasCounterpartySelected === isNoCounterpartySelected) {
        return {
            hasCounterparty: undefined,
            withEmptyOrUnverifiedCounterparty: undefined,
        };
    }
    return isHasCounterpartySelected
        ? {
              hasCounterparty: true,
              withEmptyOrUnverifiedCounterparty: undefined,
          }
        : {
              hasCounterparty: undefined,
              withEmptyOrUnverifiedCounterparty: true,
          };
}

/**
 * Simplified counterparty filter for transaction task templates.
 * Toggles "Has counterparty" / "Does not have counterparty" without the pick list.
 */
export const TemplateCounterpartyFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value: FilterMultiselectValue[] = [
        ...(filters.hasCounterparty ? [HAS_COUNTERPARTY] : []),
        ...(filters.withEmptyOrUnverifiedCounterparty ? [NO_COUNTERPARTY] : []),
    ];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(selected) =>
                    onChange({
                        ...counterpartyPresenceFromSelection(selected),
                        counterpartiesIds: undefined,
                    })
                }
                name="templateCounterparty"
                onBlur={noop}
            />
        </div>
    );
};
